import Testimonials from './Testimonials';
import useReveal from '../hooks/useReveal';

export default function About() {
  const revealRef = useReveal();

  return (
    <div ref={revealRef}>
      <section className="about-hero" aria-labelledby="about-heading">
        <h2 id="about-heading" className="about-heading">About</h2>
        <div className="about-grid">
          <div className="about-bio">
            <p className="about-text">
              I'm a Principal Product Designer at Nextiva with over eight years in product design. I design AI products for support and sales teams and the small businesses they serve, and I build and evolve design systems that keep the work consistent across teams.
            </p>
            <p className="about-text">
              My background is in computer science, and it shapes how I work. I take a complex system, figure out what people need to understand about it, and prototype with real tools so teams can react to something that works. The case studies show how that plays out, especially where trust and control matter.
            </p>
          </div>
          <aside className="about-details" aria-label="Quick details">
            <div className="about-detail-item">
              <span className="about-detail-label">Currently</span>
              <span className="about-detail-value">Nextiva</span>
            </div>
            <div className="about-detail-item">
              <span className="about-detail-label">Focus</span>
              <span className="about-detail-value">AI products, design systems, enterprise UX</span>
            </div>
            <div className="about-detail-item">
              <span className="about-detail-label">Experience</span>
              <span className="about-detail-value">8+ years in product design</span>
            </div>
            <div className="about-detail-item">
              <span className="about-detail-label">Background</span>
              <span className="about-detail-value">Computer science</span>
            </div>
          </aside>
        </div>
      </section>
      <div className="reveal">
        <Testimonials />
      </div>
    </div>
  );
}
